/* eslint-disable */
import request from '../utils/request'

export const getData = (startDate, endDate) => request({
  method: 'get',
  url: `/taxi/statistics/personal_drivers_result?start_date=${startDate}&end_date=${endDate}`
})
